import { useTranslation } from "react-i18next";
import {
  DEFAULT_LANGUAGE,
  isSupportedLanguage,
  type SupportedLanguage,
} from "./config";

function stripLanguagePrefix(path: string): string {
  const match = path.match(/^\/([a-z]{2})(\/|$)/);
  if (match && isSupportedLanguage(match[1]) && match[1] !== DEFAULT_LANGUAGE) {
    return path.slice(`/${match[1]}`.length) || "/";
  }
  return path;
}

export function buildLocalizedPath(path: string, lng: SupportedLanguage): string {
  const clean = stripLanguagePrefix(path);
  if (lng === DEFAULT_LANGUAGE) return clean;
  return clean === "/" ? `/${lng}` : `/${lng}${clean}`;
}

/**
 * Returns a function that takes an English-canonical path and returns it
 * prefixed with the active language when relevant. Use for <Link to={lp("/pricing")}>.
 */
export function useLocalizedPath() {
  const { i18n } = useTranslation();
  const lng: SupportedLanguage = isSupportedLanguage(i18n.language)
    ? i18n.language
    : DEFAULT_LANGUAGE;
  return (path: string) => buildLocalizedPath(path, lng);
}

export { stripLanguagePrefix };
